var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16634 14.6668H13.833C14.1866 14.6668 14.5258 14.5264 14.7758 14.2763C15.0259 14.0263 15.1663 13.6871 15.1663 13.3335V2.66683C15.1663 2.31321 15.0259 1.97407 14.7758 1.72402C14.5258 1.47397 14.1866 1.3335 13.833 1.3335H5.83301C5.47939 1.3335 5.14025 1.47397 4.8902 1.72402C4.64015 1.97407 4.49967 2.31321 4.49967 2.66683V13.3335C4.49967 13.6871 4.3592 14.0263 4.10915 14.2763C3.8591 14.5264 3.51996 14.6668 3.16634 14.6668ZM3.16634 14.6668C2.81272 14.6668 2.47358 14.5264 2.22353 14.2763C1.97348 14.0263 1.83301 13.6871 1.83301 13.3335V7.3335C1.83301 6.60016 2.43301 6.00016 3.16634 6.00016H4.49967M12.4997 9.3335H7.16634M10.4997 12.0002H7.16634",
    stroke: "black",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16602 4H12.4993V6.66667H7.16602V4Z",
    stroke: "black",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsIcon);
export default __webpack_public_path__ + "static/media/NewsIcon.1674e0afd32379aa6dd692d5d28f238f.svg";
export { ForwardRef as ReactComponent };